import { createContext, useContext, useState, useEffect } from "react";
import API_BASE_URL from "config/api";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  // ✅ 사용자 정보 불러오기
  const fetchUserData = async () => {
    const token = localStorage.getItem("access_token");
    if (!token) return;

    try {
      const response = await fetch(`${API_BASE_URL}/api/users/me/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.ok) {
        const data = await response.json();
        setUser(data);
      }
    } catch (error) {
      console.error("Failed to fetch user:", error);
    }
  };

  // ✅ 처음 마운트 + WebSocket 연결
  useEffect(() => {
    fetchUserData();

    const token = localStorage.getItem("access_token");
    if (!token) return;

    const wsScheme = window.location.protocol === "https:" ? "wss" : "ws";
    const wsUrl =
      process.env.NODE_ENV === "development"
        ? `${wsScheme}://localhost:8000/ws/user-tier/?token=${token}`
        : `${wsScheme}://${window.location.host}/ws/user-tier/?token=${token}`;

    const socket = new WebSocket(wsUrl);

    socket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.membership_tier) {
        setUser((prev) => ({ ...prev, membership_tier: data.membership_tier }));
      }
    };

    socket.onclose = () => console.log("🔌 WebSocket closed (UserContext)");

    return () => socket.close();
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser, fetchUserData }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);